module.exports = __webpack_public_path__ + "static/media/a4.32e835c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhangxinyuan/a4.mp3
// module id = kRu5
// module chunks = 0